import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Courses from './pages/Courses';
import Gallery from './pages/Gallery';
import Projects from './pages/Projects';
import ProjectHouse from './pages/ProjectHouse';
import ProjectNeznayka from './pages/ProjectNeznayka';
import ProjectHarryPotter from './pages/ProjectHarryPotter';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/house" element={<ProjectHouse />} />
          <Route path="/projects/neznayka" element={<ProjectNeznayka />} />
          <Route path="/projects/harrypotter" element={<ProjectHarryPotter />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;